import { useAnalytics } from "../../../components";
import { TrelloTemplateModel } from "../../../models";
import { getColorsFromBackgroundField } from "../../../styles";

import {
    Template,
    TemplateHero,
    TemplateContent,
    TemplateAvatar,
    ReducedTemplateHero
} from "./TrelloTemplate.styles";

type TrelloTemplateProps = {
    disabled?: boolean;
    model: TrelloTemplateModel;
    reduced?: boolean;
};

const TrelloTemplate = ({
    disabled,
    model: { id, content },
    reduced
}: TrelloTemplateProps) => {
    const { sendTrackEvent } = useAnalytics();

    const {
        attribution,
        avatar,
        avatarPadding,
        backgroundImage,
        description,
        title
    } = content;

    return (
        <Template
            data-testid="individual-template"
            data-uuid={id}
            draggable="false"
            href={content.url}
            onClick={(e) => {
                if (disabled) {
                    e.preventDefault();
                    return;
                }
                sendTrackEvent("clickedLinkInGallery", {
                    event: "clicked",
                    eventComponent: "link",
                    eventContainer: "gallery",
                    href: content.url,
                    label: content.title,
                    labelEnglish: content.entryTitle,
                    uuid: id
                });
            }}
        >
            {reduced ? (
                <ReducedTemplateHero
                    image={backgroundImage?.content.image.url}
                    {...getColorsFromBackgroundField(content.background)}
                />
            ) : (
                <TemplateHero
                    image={backgroundImage?.content.image.url}
                    {...getColorsFromBackgroundField(content.background)}
                />
            )}
            <TemplateContent>
                <TemplateAvatar image={avatar} padding={avatarPadding} />
                <h3>{title}</h3>
                {attribution && <p className="muted">{attribution}</p>}
                <p>{description}</p>
            </TemplateContent>
        </Template>
    );
};

export default TrelloTemplate;
